"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const format_1 = require("@/utils/format");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const TokenSign_1 = __importDefault(require("../layout/TokenSign"));
const styledComponents_1 = require("../styledComponents");
const CustomChartToolTip = ({ active, payload, label, customPayload, data }) => {
    if (active && customPayload && customPayload.length) {
        const data = payload[0]?.payload;
        const tooltipInfo = customPayload?.find((d) => d?.date === data?.date);
        console.log(customPayload, data, tooltipInfo);
        return (react_1.default.createElement(styledComponents_1.TooltipContainer, null,
            react_1.default.createElement(styledComponents_1.TooltipLabel, null, label),
            tooltipInfo && Object.keys(tooltipInfo)?.map((e, i) => {
                if (e !== 'date') {
                    return (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                        react_1.default.createElement(material_1.Box, { sx: {
                                paddingBottom: e === 'total' ? '5px' : e === 'totalSupply' ? '5px' : 0,
                                fontWeight: e === 'total' ? 600 : e === 'totalSupply' ? 600 : 300,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                            } },
                            react_1.default.createElement(material_1.Box, { sx: { textTransform: 'capitalize' } },
                                (0, format_1.formatLabel)(e),
                                "\u00A0:"),
                            react_1.default.createElement(material_1.Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingLeft: '15px',
                                } },
                                "\u00A0",
                                typeof tooltipInfo[e] === 'number'
                                    ? (0, format_1.formatAmount)(tooltipInfo[e])
                                    : tooltipInfo[e],
                                react_1.default.createElement(TokenSign_1.default, { token: "OGY" })))));
                }
            })));
    }
};
exports.default = CustomChartToolTip;
